// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState, useEffect } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', danger: '#B03020', success: '#2E6B4A',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

const RELATION_LABELS = {
  owner: 'Owner', renter: 'Renter', property_manager: 'Property Manager',
  family_member: 'Family Member', caretaker: 'Caretaker', guest: 'Guest', member: 'Member',
}

export default function InviteAccept({ token, session }) {
  const [invite, setInvite] = useState(null)
  const [pageStatus, setPageStatus] = useState('loading')
  const [error, setError] = useState(null)

  useEffect(() => { loadInvite() }, [token])

  useEffect(() => {
    if (session?.user && pageStatus === 'valid' && invite) {
      checkAlreadyMember()
    }
  }, [session?.user?.id, pageStatus])

  const loadInvite = async () => {
    if (!token) { setPageStatus('invalid'); return }
    const { data, error: fetchError } = await supabase
      .from('invites')
      .select('*')
      .eq('token', token)
      .single()
    if (fetchError || !data) { setPageStatus('invalid'); return }
    setInvite(data)
    if (data.status === 'accepted') { setPageStatus('already_accepted'); return }
    if (new Date(data.expires_at) < new Date()) { setPageStatus('expired'); return }
    setPageStatus('valid')
  }

  const checkAlreadyMember = async () => {
    if (!invite || !session?.user) return
    const { data } = await supabase
      .from('home_members').select('id')
      .eq('home_id', invite.home_id).eq('user_id', session.user.id).single()
    if (data) setPageStatus('already_member')
  }

  const handleAccept = async () => {
    if (!session?.user) {
      localStorage.setItem('pending_invite_token', token)
      window.location.href = '/'
      return
    }
    setPageStatus('joining')
    try {
      const { error: memberError } = await supabase.from('home_members').insert({
        home_id: invite.home_id,
        user_id: session.user.id,
        role: invite.role || 'member',
        relation: invite.relation || 'member',
        invited_email: invite.invited_email,
      })
      if (memberError) throw memberError
      await supabase.from('invites').update({ status: 'accepted' }).eq('id', invite.id)
      supabase.functions.invoke('notify-owner', {
        body: {
          event: 'invite_accepted',
          data: {
            invitee_email: invite.invited_email,
            home_address: invite.home_address || homeAddr,
            relation: invite.relation,
            accepted_at: new Date().toISOString(),
          },
        },
      }).catch(() => {})
      setPageStatus('joined')
    } catch (err) {
      setError(err.message)
      setPageStatus('error')
    }
  }

  const homeAddr = invite?.home_address || 'a home on Casavio'
  const btnStyle = {
    display: 'block', width: '100%', textAlign: 'center',
    background: `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`,
    color: C.card, padding: '14px', borderRadius: '10px',
    textDecoration: 'none', fontSize: '14px', fontWeight: '700',
    letterSpacing: '1px', textTransform: 'uppercase', border: 'none', cursor: 'pointer', fontFamily: f,
  }

  return (
    <div style={{ minHeight: '100vh', background: C.bg, fontFamily: f, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div style={{ background: C.card, borderRadius: '20px', padding: '40px 36px', width: '100%', maxWidth: '460px', boxShadow: '0 8px 40px rgba(44,29,20,0.12)', border: `1px solid ${C.border}` }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '24px', fontWeight: '700', color: C.amber, letterSpacing: '4px', marginBottom: '4px' }}>CASAVIO</div>
          <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs }}>Home Management</div>
        </div>

        {pageStatus === 'loading' && (
          <div style={{ textAlign: 'center', color: C.muted, fontFamily: fs, padding: '24px 0' }}>Loading invitation...</div>
        )}

        {pageStatus === 'invalid' && (
          <>
            <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown, marginBottom: '12px', textAlign: 'center' }}>Invitation Not Found</div>
            <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, textAlign: 'center', marginBottom: '24px' }}>This link is invalid or has already been used.</div>
            <a href="/" style={btnStyle}>Go to Casavio</a>
          </>
        )}

        {pageStatus === 'expired' && (
          <>
            <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown, marginBottom: '12px', textAlign: 'center' }}>Invitation Expired</div>
            <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, textAlign: 'center', marginBottom: '24px', lineHeight: 1.6 }}>
              The invitation to <strong>{homeAddr}</strong> has expired. Ask the homeowner to send a new invite.
            </div>
            <a href="/" style={{ ...btnStyle, background: 'transparent', color: C.amber, border: `1px solid ${C.amber}`, textDecoration: 'none' }}>Go to Casavio</a>
          </>
        )}

        {pageStatus === 'already_accepted' && (
          <>
            <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown, marginBottom: '12px', textAlign: 'center' }}>Already Accepted</div>
            <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, textAlign: 'center', marginBottom: '24px' }}>
              This invitation has already been accepted. Sign in to access <strong>{homeAddr}</strong>.
            </div>
            <a href="/" style={btnStyle}>Sign In to Casavio</a>
          </>
        )}

        {pageStatus === 'already_member' && (
          <>
            <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown, marginBottom: '12px', textAlign: 'center' }}>Already a Member</div>
            <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, textAlign: 'center', marginBottom: '24px' }}>
              You already have access to <strong>{homeAddr}</strong>.
            </div>
            <a href="/" style={btnStyle}>Go to Dashboard</a>
          </>
        )}

        {pageStatus === 'valid' && invite && (
          <>
            <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown, marginBottom: '8px', textAlign: 'center' }}>You've been invited!</div>
            <div style={{ background: C.bg, borderRadius: '12px', border: `1px solid ${C.border}`, padding: '16px 20px', marginBottom: '24px' }}>
              <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, lineHeight: 1.7 }}>
                <div style={{ marginBottom: '6px' }}><strong style={{ color: C.brown }}>Home:</strong> {homeAddr}</div>
                <div><strong style={{ color: C.brown }}>Your role:</strong> <span style={{ color: C.amber }}>{RELATION_LABELS[invite.relation] || invite.relation}</span></div>
              </div>
            </div>
            {session?.user ? (
              <button style={btnStyle} onClick={handleAccept}>Accept &amp; Join</button>
            ) : (
              <>
                <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs, textAlign: 'center', marginBottom: '16px' }}>
                  Sign in or create an account to accept this invitation.
                </div>
                <button style={btnStyle} onClick={handleAccept}>Sign In to Accept</button>
              </>
            )}
          </>
        )}

        {pageStatus === 'joining' && (
          <div style={{ textAlign: 'center', color: C.muted, fontFamily: fs, padding: '24px 0' }}>Joining home...</div>
        )}

        {pageStatus === 'joined' && (
          <>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>🏠</div>
              <div style={{ fontSize: '22px', fontWeight: '700', color: C.brown, marginBottom: '8px' }}>Welcome!</div>
              <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, marginBottom: '24px', lineHeight: 1.6 }}>
                You now have access to <strong>{homeAddr}</strong>.
              </div>
            </div>
            <a href="/" style={btnStyle}>Go to Dashboard</a>
          </>
        )}

        {pageStatus === 'error' && (
          <>
            <div style={{ fontSize: '22px', fontWeight: '700', color: C.danger, marginBottom: '12px', textAlign: 'center' }}>Something went wrong</div>
            <div style={{ fontSize: '14px', color: C.muted, fontFamily: fs, textAlign: 'center', marginBottom: '24px' }}>{error}</div>
            <a href="/" style={{ ...btnStyle, background: 'transparent', color: C.amber, border: `1px solid ${C.amber}`, textDecoration: 'none' }}>Go to Casavio</a>
          </>
        )}
      </div>
    </div>
  )
}
